/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown>, interval: NonNullable<unknown>, date: NonNullable<unknown> }} Plan_Change_Next_ChargeInputs */

const en_plan_change_next_charge = /** @type {(inputs: Plan_Change_Next_ChargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Then ${i?.amount} per ${i?.interval} from ${i?.date}`)
};

const es_plan_change_next_charge = /** @type {(inputs: Plan_Change_Next_ChargeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Después ${i?.amount} por ${i?.interval} a partir del ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Then {amount} per {interval} from {date}" |
*
* @param {Plan_Change_Next_ChargeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_change_next_charge = /** @type {((inputs: Plan_Change_Next_ChargeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Change_Next_ChargeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_change_next_charge(inputs)
	return en_plan_change_next_charge(inputs)
});